var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSpeakerOff = function SvgSpeakerOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-182.000000, -120.000000)",
    fill: "#151B22",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175,110 C175,108.038889 173.866667,106.344444 172.222222,105.527778 L172.222222,107.983333 L174.95,110.711111 C174.983333,110.477778 175,110.238889 175,110 L175,110 Z M177.777778,110 C177.777778,111.044444 177.55,112.027778 177.177778,112.933333 L178.861111,114.616667 C179.583333,113.233333 180,111.666667 180,110 C180,105.244444 176.672222,101.266667 172.222222,100.255556 L172.222222,102.55 C175.433333,103.505556 177.777778,106.477778 177.777778,110 Z M161.416667,100 L160,101.416667 L165.25,106.666667 L160,106.666667 L160,113.333333 L164.444444,113.333333 L170,118.888889 L170,111.416667 L174.727778,116.144444 C173.983333,116.716667 173.144444,117.177778 172.222222,117.455556 L172.222222,119.75 C173.75,119.4 175.144444,118.7 176.316667,117.738889 L178.583333,120 L180,118.583333 L170,108.583333 L161.416667,100 Z M170,101.111111 L167.677778,103.433333 L170,105.755556 L170,101.111111 Z",
    id: "Sound-off"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpeakerOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speaker-off.8b7db5a7.svg";
export { ForwardRef as ReactComponent };